import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Guard user-supplied URLs before rendering them as an anchor href.
 * Only http/https URLs are allowed; javascript:, data:, and other schemes
 * (which can execute code on click) return null so the caller can skip the link.
 *
 * @param {unknown} url - Candidate URL, typically from admin-controlled data.
 * @returns {string|null} The URL if safe, otherwise null.
 */
export function isSafeExternalUrl(url) {
  return typeof url === "string" && /^https?:\/\//i.test(url.trim())
    ? url.trim()
    : null;
}

